export default {
  'registerBenefit.member_recruitment': 'สมัครสมาชิกเพื่อรับสิทธิพิเศษ',
  'registerBenefit.apply': 'สมัครสมาชิก',
  'registerBenefit.follow_friend_tip':
    'เพิ่มเราเป็นเพื่อนของแบรนด์เพื่อรับการแจ้งเตือนสิทธิประโยชน์',
} as Record<string, string>;
